import React, { Component, Fragment } from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';

class CardSalesIframe extends Component {
  componentDidMount() {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            text: 'Reports',
            name: 'reports',
            type: 'ui_tab',
          },
          {
            text: 'Card sales',
          },
        ],
      },
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Fragment>
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `.react-page { height: 100% }`,
          }}
        />
        <iframe
          title="Compare credit and debit card sales with payouts."
          src={`/webapps_redirect.php?app=retail-reports&next=${encodeURIComponent(
            `/payments/overview${window.location.search}`
          )}`}
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        />
      </Fragment>
    );
  }
}

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(CardSalesIframe))
);
